import { Component, OnInit,AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { RegistrationService } from '../registration.service';
import { $ } from 'protractor';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-content-recharge',
  templateUrl: './content-recharge.component.html',
  styleUrls: ['./content-recharge.component.css']
})
export class ContentRechargeComponent implements OnInit {

  registerForm  : UntypedFormGroup;
  contactUsForm : UntypedFormGroup;
  contactUsFormVo : UntypedFormGroup;
  contactUsFormTab : UntypedFormGroup;
  askForADemoForm : UntypedFormGroup;
  submitted = false;
  cosubmitted = false;
  vosubmitted = false;
  tabsubmitted = false;
  public isSaving = false;
  public is_entity_company = false;
  public is_vw_creative = true;
  public ask_for_a_demo  = true;
  entity_types = []; 
  source_types = [];
  martial_types = []; 
  state_types: any = ['NCR', 'UP','MP']; 
  city_types : any = ['A','B','D'];
  v_names = [];
  vr_names = [];
  vc_names = [];
  v_tenure = [];
  _booking_no = '';
  _otp  = '';
  _customer_mob = '';
  _msg_otp = '';
  _request_otp_no = '';
  _valid_otp = '';
  _service_url = '';
  pan_files: File = null;
  dl_files: File = null;
  res_files : File = null;
  _channel_id = '';
  company_firms_datails = null;
  enitity_type_vlaue = null;
  cities_types = '';
  contact_cities_types = '';
  vo_cities_types  = '';
  tab_cities_types = '';
  tabs_cities_types = '';
  demo_cities_types = '';
  tab_report_types = '';
  to_tab_report_types = '';
  states_types = '';
  dealers_data = '';
  _city_id = '';
  _dob_label = '';
  _cr_address_label = '';
  _pan_card_label   = '';
   _address_proof    = '';
   _firm_name = '';
   _is_dl_allow= false;
   _is_res_allow = false;
    minDate: Date;
    maxDate: Date;
    dateFormat : '';
    utm_emailer = '';
    hideBasicInfo = true;
    minimum_date : Date;
    maximum_date : Date;
    minimum_date_demo : Date;
    maximum_date_demo : Date;
  constructor(private formBuilder: UntypedFormBuilder,private _RegistrationService:RegistrationService,private router: ActivatedRoute,
    private contactUsFormBuilder:UntypedFormBuilder,
    private contactUsFormBuilderVo:UntypedFormBuilder,
    private contactUsFormBuilderTab:UntypedFormBuilder,
    private askForDemoFormBuilderTab:UntypedFormBuilder
    ) { 
   
    
     const currentPath = window.location.pathname;
     
      if((currentPath === '/takeABreak' || currentPath === '/takeABreak/')) {
         //window.location.href ='https://hub.orixindia.com/takeABreak?utm_source=take_a_break';
         //return;
      }

    this.getVehicleName();
    this.getVarientName();
    this.getColorName();
    this.getTenure();
    this.getEntityType();
    this.getSourceLocation();
    this.getMaritalStatus(); 
    this.getState();
    this.getCity();
    this.getContactCity();
    this.getVoCity();
    this.getTabCity();
    this.getTimeArray();
    this.getDealers();
    this.getTbNewCity();
    this.getDemoCity();
    this._msg_otp = '';
    this._request_otp_no = '';
    this._dob_label = 'Date Of Birth';
    this._cr_address_label = 'Current Residential Address';
    this._pan_card_label   = 'Permanent Account Number Copy';
    this._address_proof    = 'Residence Address Proof Copy';
    this._firm_name        = 'First Name';
    this.minDate = new Date();
    this.maxDate = new Date();
    this.minDate.setDate(this.minDate.getDate() - 460000);
    this.maxDate.setDate(this.maxDate.getDate() - 6570);

    this.minimum_date = new Date();
    this.maximum_date = new Date();
    this.minimum_date.setDate(this.minimum_date.getDate()+1);
    this.maximum_date.setDate(this.maxDate.getDate() + 565);
    this.minimum_date_demo = new Date();
    this.minimum_date_demo.setDate(this.minimum_date.getDate()+1);
    this.maximum_date_demo = new Date();
    this.maximum_date_demo.setDate(this.maxDate.getDate() + 565)

    
   
    this.hideBasicInfo = false; 
    this.is_vw_creative = true;
    this.ask_for_a_demo = true;

   
    }
 

   ngOnInit() {
    
    
       
        this.utm_emailer = this.router.snapshot.queryParamMap.get('utm_source');

        // ✅ Redirect if URL is /takeABreak or /takeABreak/ WITHOUT utm_source
        if ((!this.utm_emailer || this.utm_emailer.trim() === '' )) {
          window.location.href =
            'https://hub.orixindia.com/takeABreak?utm_source=take_a_break';
          return;
        }

        if (this.utm_emailer !== 'take_a_break') {
         window.location.href =
          'https://hub.orixindia.com/takeABreak?utm_source=take_a_break';
          return;
      }



    
    
    //  if(this.utm_emailer == 'emailer'){
     
    //   let element:HTMLElement = document.getElementById('contact_us_form_msg') as HTMLElement;
    //   element.click(); 
    // }
    
    // if(this.utm_emailer == 'vw_emailer'){
    //   this.is_vw_creative = false;
    //   let element:HTMLElement = document.getElementById('vw_creative_form_msg') as HTMLElement;
    //   element.click(); 
    // } 

    if(this.utm_emailer == 'take_a_break'){
      this.is_vw_creative = false;
      let element:HTMLElement = document.getElementById('take_a_break_creative_form_msg') as HTMLElement;
      element.click(); 
    }

    // if(this.utm_emailer == 'ask_for_a_demo'){
    //   this.is_vw_creative = false; // by default page hide
    //   let element:HTMLElement = document.getElementById('ask_for_a_demo_form_msg') as HTMLElement;
    //   element.click(); 
    // }

     this.registerForm = this.formBuilder.group({
          
          entity_type : ['',Validators.required],
          company_firms_datails: [''],
          first_name: ['', [Validators.maxLength(25),
          Validators.minLength(3),
          Validators.required]],
          last_name: ['',  [Validators.maxLength(25),
            Validators.minLength(3),
           
          Validators.pattern('^(?=.*[a-zA-Z])[a-zA-Z0-9]+$')]],
          date_of_birth: ['',Validators.required],
          marital_status : [''],
          mobile_no : ['',[Validators.required,Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
          state : ['',Validators.required],
          city  : ['',Validators.required],
          pin_code  : ['',[Validators.required,Validators.pattern('[0-9]{6}')]],
          terms_and_condition : ['',Validators.required],
          pan_card_no : ['',[Validators.required,Validators.pattern("^[A-Za-z]{5}[0-9]{4}[A-Za-z]$")]],
          current_residential_address  : ['',[
          Validators.maxLength(100),
          Validators.minLength(6),
          Validators.required,
          ]],
          vehicle_name  : ['',Validators.required],
          color  : ['',Validators.required],
          variant  : ['',Validators.required],
          dealer_name : ['',Validators.required],
          tenure : ['',Validators.required],
          pan_card_copy : ['',[Validators.required]],
          residence_copy : [''],
          dl_copy : [''],
          dl_no : [''],
          otp_request : ['',Validators.required],
          email_id: ['', [Validators.required, Validators.email]]
         
      });
     this.contactUsForm = this.contactUsFormBuilder.group({
        email_id: ['', [Validators.required, Validators.email]],
        mobile_no  : ['',[Validators.required,Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
        city       : ['',Validators.required],
        });
      this.contactUsFormVo = this.contactUsFormBuilderVo.group({
          first_name: ['', [Validators.maxLength(25),
                          Validators.minLength(3),
                            Validators.required]],
          email_id: ['', [Validators.required, Validators.email]],
          mobile_no  : ['',[Validators.required,Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
          city       : ['',Validators.required],
          });
      this.contactUsFormTab = this.contactUsFormBuilderTab.group({
            first_name: ['', [Validators.maxLength(25),
                            Validators.minLength(3),
                              Validators.required]],
            email_id: ['', [Validators.required, Validators.email,Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]],
            mobile_no  : ['',[Validators.required,Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
            city       : ['',Validators.required],
            company_name : ['',Validators.required],
            car : ['',Validators.required],
            start_date_and_time : ['',Validators.required],
            start_time : ['',Validators.required],
            end_date_and_time : ['',Validators.required],
            end_report_time : ['',Validators.required],
            reporting_address_landmark : ['',Validators.required,Validators.maxLength(100)],
            destination_address_visit : ['',Validators.required,Validators.maxLength(100)]
            });

       this.askForADemoForm = this.askForDemoFormBuilderTab.group({
              first_name: ['', [Validators.maxLength(25),
                                Validators.minLength(3),
                                Validators.required]],
              email_id: ['', [Validators.required, Validators.email,Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]],
              mobile_no  : ['',[Validators.required,Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
              company_name : ['',Validators.required],
              start_date_and_time : ['',Validators.required],
              city       : ['',Validators.required]
              
              
              });     
  }

  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls;}
  get co() { return this.contactUsForm.controls;}
  get vo() { return this.contactUsFormVo.controls;}
  get tab() { return this.contactUsFormTab.controls;}
  get ask_demo() { return this.askForADemoForm.controls;}
  
  onEntityTypeChange(ent_id)
  {
   
   if(ent_id == 3){
    this.is_entity_company = true;
    this.enitity_type_vlaue = ent_id;
    this._dob_label        = 'Date of Incorporation';
    this._cr_address_label = 'Current Address';
    this._pan_card_label   = 'Company Permanent Account Number Copy';
    this._address_proof    = 'Address Proof Copy';
    this._firm_name        = 'Company-Firm Name';
    
  
   }else{
     this.is_entity_company = false;
     this.company_firms_datails = '';
     this.enitity_type_vlaue = '';  
     this._dob_label       = 'Date Of Birth';
    this._cr_address_label = 'Current Residential Address';
    this._pan_card_label   = 'Permanent Account Number Copy';
    this._address_proof    = 'Residence Address Proof Copy';
    this._firm_name        = 'First Name';
    
    }
  
  }
  handleFileInputPan(event) {
      this.pan_files  = <File> event.target.files[0];
      this.dl_files   = <File>event.target.files[0];
      this.res_files  = <File>event.target.files[0];
      let file        = <File> event.target.files[0];
      //validation here then attribute the value to your model
     
  }
  handleFileInputDL(event) {
    
    this.dl_files = <File> event.target.files[0];
    this._is_dl_allow = true;
    }
   handleFileInputResidental(event) {
    
     this.res_files = <File>event.target.files[0];
     this._is_res_allow = true;
     
    }
  sendOtpToCustomer(){
    
    this._customer_mob = this.registerForm.value.mobile_no;
    
    if(this._customer_mob == ''){
         alert('Please enter your valid mobile no');
         return false;
    }else{
      this.isSaving = true;
      this._RegistrationService.sendOTPToCustomer(this._customer_mob)
      .subscribe(
              response =>  {
                this.isSaving = false;
                this._msg_otp = "Your OTP has been sent on "+response.mobile,
                this._request_otp_no = response.srvr_request_otp_no
                let element:HTMLElement = document.getElementById('otp_send_msg') as HTMLElement;
                element.click();
              },
              
      );
      
      }
     

}

onContactUsSubmit() {
      this.cosubmitted = true;
      if (this.contactUsForm.invalid) {
        
          return;
      }
      const cfd = new FormData(); 
      cfd.append('email_id',this.contactUsForm.get('email_id').value);
      cfd.append('mobile_no',this.contactUsForm.get('mobile_no').value);
      cfd.append('city',this.contactUsForm.get('city').value);
      cfd.append('source_contact','utm_source');
      cfd.append('source','maruti_creative_lead');
      this.isSaving = true;
      this._RegistrationService.saveContactUsForm(cfd)
         .subscribe(
                response => 
                           {
                            if(response.status == 'success'){
                              //this.contactUsForm.reset(); 
                              this.isSaving = false;
                              alert("Thanks for sharing your details, explore the cars available.");
                              window.location.href = "https://www.marutisuzuki.com/subscribe";
                              return false;
                                                             
                            }else if(response.status == 'error'){
                              alert("There are some technical issue, please try another time");
                              this.isSaving = false;
                              return false;  
                                 
                            } 
                            
                            
                         } 
                
        );
      
}

onContactUsSubmitVo() {
  this.vosubmitted = true;
  if (this.contactUsFormVo.invalid) {
    
      return;
  }
  const cfd = new FormData(); 
  cfd.append('email_id',this.contactUsFormVo.get('email_id').value);
  cfd.append('mobile_no',this.contactUsFormVo.get('mobile_no').value);
  cfd.append('city',this.contactUsFormVo.get('city').value);
  cfd.append('first_name',this.contactUsFormVo.get('first_name').value);
  cfd.append('source_contact','utm_source');
  cfd.append('source','vw_lead'); 
  this.isSaving = true;
  this._RegistrationService.saveContactUsForm(cfd)
     .subscribe(
            response => 
                       {
                        if(response.status == 'success'){
                          //this.contactUsForm.reset(); 
                          this.isSaving = false;
                          alert("Thanks for sharing your details, explore the cars available.");
                          window.location.href = "https://www.volkswagen.co.in/app/site/calculate-your-lease/";
                          return false;
                                                         
                        }else if(response.status == 'error'){
                          alert("There are some technical issue, please try another time");
                          this.isSaving = false;
                          return false;  
                             
                        } 
                        
                        
                     } 
            
    );
  
}

onContactUsSubmitTab() {
  var v_mobile_no = this.contactUsFormTab.get('mobile_no').value;
  var v_email_id = this.contactUsFormTab.get('email_id').value;
  var a = /^\d{10}$/;  
  var is_mobile_invalid = false;
  var is_email_invalid = false;
  if (a.test(v_mobile_no)){}else{ is_mobile_invalid = true} 
  
  var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if(v_email_id.match(mailformat)){}else{ is_email_invalid = true;}

  this.tabsubmitted = true;
  

   if(!this.contactUsFormTab.invalid && is_mobile_invalid ){
        return;
   }
   if(!this.contactUsFormTab.invalid && is_email_invalid ){
       return;
    }
  
  if (this.contactUsFormTab.invalid) {
    
      return;
  }
  const cfd = new FormData(); 
  var date_convert_1 = new Date(this.contactUsFormTab.get('start_date_and_time').value);
  var month_1 = date_convert_1.getMonth()+1;
  
  console.log("current_months"+date_convert_1.getMonth());
  var c_start_date_and_time = (date_convert_1.getDate() < 10 ? '0' : '') + date_convert_1.getDate()+'-'+(month_1 < 10 ? '0' : '') + month_1 +'-'+date_convert_1.getFullYear();
  
  var date_convert_2 = new Date(this.contactUsFormTab.get('end_date_and_time').value);
  var month_2 =  date_convert_2.getMonth()+1;
  var c_end_date_and_time = (date_convert_2.getDate() < 10 ? '0' : '') + date_convert_2.getDate()+'-'+(month_2 < 10 ? '0' : '') + month_2 +'-'+date_convert_2.getFullYear();
  
   //alert(c_start_date_and_time+"=====>"+c_end_date_and_time);
  

   var s_t= this.getTimeStamp(c_start_date_and_time);
   var e_t = this.getTimeStamp(c_end_date_and_time);
   //alert(s_t+"==>"+e_t);
   if(e_t >= s_t ){
   
   }else{
    //alert("End date should be greater then Start date")
    let element:HTMLElement = document.getElementById('e_take_a_break') as HTMLElement;
    element.click();
    return false;
   }
  
  cfd.append('email_id',this.contactUsFormTab.get('email_id').value);
  cfd.append('mobile_no',this.contactUsFormTab.get('mobile_no').value);
  cfd.append('city',this.contactUsFormTab.get('city').value);
  cfd.append('first_name',this.contactUsFormTab.get('first_name').value);
  cfd.append('company_name',this.contactUsFormTab.get('company_name').value);
  cfd.append('car',this.contactUsFormTab.get('car').value);
  cfd.append('start_date_and_time',c_start_date_and_time);
  cfd.append('start_time',this.contactUsFormTab.get('start_time').value);
  cfd.append('end_date_and_time',c_end_date_and_time);
  cfd.append('end_report_time',this.contactUsFormTab.get('end_report_time').value);
  cfd.append('reporting_address_landmark',this.contactUsFormTab.get('reporting_address_landmark').value);
  cfd.append('destination_address_visit',this.contactUsFormTab.get('destination_address_visit').value);
  
  
  cfd.append('source_contact','utm_source');
  cfd.append('source','take_a_break');
  console.log(c_end_date_and_time);
  console.log(c_start_date_and_time);

  this.isSaving = true;
  this._RegistrationService.saveContactUsForm(cfd)
     .subscribe(
            response => 
                       {
                        if(response.status == 'success'){
                          this.contactUsForm.reset(); 
                          this.isSaving = false;
                          alert("Thank you for sharing your details. We will get in touch with you shortly.\n For immediate assistance, please contact the ORIX 24×7 Call Center at +91-8796331265 or email us at luxurycars@orixindia.com.");
                          let element:HTMLElement = document.getElementById('s_take_a_break') as HTMLElement;
                          element.click();
                          window.location.href = "https://hub.orixindia.com/takeABreak?utm_source=take_a_break";
                          return false;
                                                         
                        }else if(response.status == 'error'){
                          alert("There are some technical issue, please try another time");
                          this.isSaving = false;
                          return false;  
                             
                        } 
                        
                } 
            
    );
  
}

AskForADemoFormSubmitTab() {
  
  var v_mobile_no = this.askForADemoForm.get('mobile_no').value;
  var v_email_id = this.askForADemoForm.get('email_id').value;
  var a = /^\d{10}$/;  
  var is_mobile_invalid = false;
  var is_email_invalid = false;
  if (a.test(v_mobile_no)){}else{ is_mobile_invalid = true} 
  
  var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if(v_email_id.match(mailformat)){}else{ is_email_invalid = true;}

  this.tabsubmitted = true;
  

   if(!this.askForADemoForm.invalid && is_mobile_invalid ){
        return;
   }
   if(!this.askForADemoForm.invalid && is_email_invalid ){
       return;
    }
  
  if (this.askForADemoForm.invalid) {
    
      return;
  }
  const cfd = new FormData(); 
  var date_convert_1 = new Date(this.askForADemoForm.get('start_date_and_time').value);
  var month_1 = date_convert_1.getMonth()+1;
  
  console.log("current_months"+date_convert_1.getMonth());
  var c_start_date_and_time = (date_convert_1.getDate() < 10 ? '0' : '') + date_convert_1.getDate()+'-'+(month_1 < 10 ? '0' : '') + month_1 +'-'+date_convert_1.getFullYear();
  
  
  
   //alert(c_start_date_and_time+"=====>"+c_end_date_and_time);
  

   var s_t= this.getTimeStamp(c_start_date_and_time);
   
  
  cfd.append('email_id',this.askForADemoForm.get('email_id').value);
  cfd.append('mobile_no',this.askForADemoForm.get('mobile_no').value);
  cfd.append('city',this.askForADemoForm.get('city').value);
  cfd.append('first_name',this.askForADemoForm.get('first_name').value);
  cfd.append('company_name',this.askForADemoForm.get('company_name').value);
  cfd.append('start_date_and_time',c_start_date_and_time);
  cfd.append('source_contact','utm_source');
  cfd.append('source','ask_for_a_demo');
  
  console.log(c_start_date_and_time);
   
  this.isSaving = true;
  this._RegistrationService.saveContactUsForm(cfd)
     .subscribe(
            response => 
                       {
                        if(response.status == 'success'){
                          this.askForADemoForm.reset(); 
                          this.isSaving = false;
                         // alert("Thank you for sharing your details. We will connect with you, shortly.\n ORIX 24 x 7 Call Centre: +91 8796331265 or reservation.desk@orixindia.com");
                          let element:HTMLElement = document.getElementById('msg_ask_for_demo') as HTMLElement;
                          element.click();
                          window.location.href = "https://hub.orixindia.com/takeABreak?utm_source=take_a_break";
                          return false;
                                                         
                        }else if(response.status == 'error'){
                          alert("There are some technical issue, please try another time");
                          this.isSaving = false;
                          return false;  
                             
                        } 
                        
                } 
            
    );
  
}
 getTimeStamp(input) {
  var parts = input.trim().split(' ');
  var date = input.split('-');
  //console.log(date);
  //alert(date[2]+"-"+date[1]+"-"+date[0]);
  // NOTE:: Month: 0 = January - 11 = December.
   var d = new Date(date[2]+"-"+date[1]+"-"+date[0]);
   return Math.round(d.valueOf() / 1000);
   //return Math.round(d.getTime() / 1000);

}
  onSubmit() {
      this.submitted = true;
      // stop here if form is invalid
     
      if (this.registerForm.invalid) {
        document.documentElement.scrollTop = 30;
          return;
      }else{
         //alert('All Validation OK'); 
        // return false;
        const fd = new FormData(); 
        fd.append('upload_pan_img',this.pan_files,this.pan_files.name);
        console.log(this.dl_files);

        if(this.dl_files.name != '' && this._is_dl_allow){
          fd.append('upload_dl_img', this.dl_files,this.dl_files.name);
        }else{
          fd.append('upload_dl_img',"blank");
        }
        
        if(this.dl_files.name != '' && this._is_res_allow){
          fd.append('upload_res_img', this.dl_files,this.res_files.name);
        }else{
          fd.append('upload_res_img',"blank");
        }
        


        
         var date_convert = new Date(this.registerForm.get('date_of_birth').value);
         var c_date_of_birth = (date_convert.getDate() < 10 ? '0' : '') + date_convert.getDate()+'-'+(date_convert.getMonth() < 10 ? '0' : '') + date_convert.getMonth()+'-'+date_convert.getFullYear();
         
        
        fd.append('session_store',this._request_otp_no)
       
        fd.append('entity_type',this.registerForm.get('entity_type').value);
        fd.append('first_name',this.registerForm.get('first_name').value);
        fd.append('last_name',this.registerForm.get('last_name').value);
        fd.append('date_of_birth',c_date_of_birth);
        fd.append('marital_status',this.registerForm.get('marital_status').value);
        fd.append('mobile_no',this.registerForm.get('mobile_no').value);
       
        fd.append('state',this.registerForm.get('state').value);
        fd.append('city',this.registerForm.get('city').value);
        fd.append('pin_code',this.registerForm.get('pin_code').value);
       
        fd.append('terms_and_condition',this.registerForm.get('terms_and_condition').value);
        fd.append('pan_card_no',this.registerForm.get('pan_card_no').value);
        fd.append('dl_no',this.registerForm.get('dl_no').value);
        fd.append('current_residential_address',this.registerForm.get('current_residential_address').value);
       
        fd.append('vehicle_name',this.registerForm.get('vehicle_name').value);
        fd.append('color',this.registerForm.get('color').value); //it is varients
        fd.append('variant',this.registerForm.get('variant').value); //it is model
        fd.append('tenure',this.registerForm.get('tenure').value);
        fd.append('dealer_name',this.registerForm.get('dealer_name').value);
        fd.append('pan_card_copy',this.registerForm.get('pan_card_copy').value);
        fd.append('residence_copy',this.registerForm.get('residence_copy').value);
        
        fd.append('otp_request',this.registerForm.get('otp_request').value);
        fd.append('email_id',this.registerForm.get('email_id').value);
        fd.append('source','subscription_lead');       
       // this.isSaving = true;
        
        this.registerForm.value.session_store = this._request_otp_no;
        this._RegistrationService.saveCustomerInfoToServer(fd)
        
        .subscribe(
                response => 
                           {
                            if(response.status == 'success'){
                               if(this._request_otp_no !=''){
                                this.registerForm.reset(); 
                                this._valid_otp = ''; 
                                this.isSaving = false;
                                this._booking_no = "Your Subscription has been created and your subscription booking no. "+response.resp_data.booking_no
                                let element:HTMLElement = document.getElementById('booking_confirm_send_msg') as HTMLElement;
                                element.click(); 
                              }
                               
                            }else if(response.status == 'error'){
                                 this._valid_otp = response.message;
                                 this.isSaving = false;
                                 let element:HTMLElement = document.getElementById('invalid_send_msg') as HTMLElement;
                                 element.click();
                                 
                            } 
                            
                            
                         } 
                
        );
      }
       
     
  }
 day_of_the_month(d)
{ 
  return (d.getDate() < 10 ? '0' : '') + d.getDate();
}
  onChannelChange(channel_id){
       this._channel_id  = channel_id;
       this.isSaving = true;
       this._RegistrationService.geMyVarient(channel_id).subscribe(data => {
        this.getRespectedDealers();
        this.vr_names = data.resp_data
       });
  }
  onCityChangeChange(city_id){
    this._city_id = city_id;
    this.getRespectedDealers();
  }
  isAllowDate(start_date){
      alert(start_date);
  }
  getRespectedDealers(){
      
       const d_fd  = new FormData(); 
       this.isSaving = true;
       d_fd.append('city_id',this._city_id);
       d_fd.append('s_channel_id', this._channel_id);
     
       this._RegistrationService.getCityBasedBasedDealers(d_fd).subscribe(response =>{
         
         this.dealers_data = response.resp_data;
         this.isSaving = false;
       } ); 
      
  }
 

  getVehicleName(){
       this._RegistrationService.getVName().subscribe(data => this.v_names = data.resp_data);
  }
  

  getVarientName(){
    this._RegistrationService.getVrName().subscribe(data => this.vr_names = data.resp_data);
  }
  getColorName(){
    this._RegistrationService.getVcName().subscribe(data => this.vc_names = data.resp_data);
  }
  getTenure(){
    this._RegistrationService.getTenure().subscribe(data => this.v_tenure = data.resp_data);
    
  }

  getEntityType(){
    this.isSaving = true;
    this._RegistrationService.getEntity().subscribe(data => {
                                                             this.entity_types  = data.resp_data; 
                                                             this.isSaving = false;});
  }
  getSourceLocation(){
    this._RegistrationService.getSource().subscribe(data => this.source_types = data.resp_data);
  }
  getMaritalStatus(){
    this._RegistrationService.getMarital().subscribe(data => this.martial_types = data.resp_data);
  }

  getState(){
    this._RegistrationService.getStateService().subscribe(data => this.states_types = data.resp_data);
  }

  getCity(){
    this._RegistrationService.getCityService().subscribe(data => this.cities_types = data.resp_data);
  }


  onStateChangeChange(state_id){
    this.isSaving = true;
    this._RegistrationService.onCityChangeService(state_id).subscribe(data => {this.cities_types = data.resp_data;  this.isSaving = false;});
}

onModelVarientChange(model_id){
  
  const v_fd  = new FormData(); 
  v_fd.append('s_model_id',model_id);
  v_fd.append('s_channel_id', this._channel_id);
  this.isSaving = true;
  this._RegistrationService.geMyModelVarient(v_fd).subscribe(response =>{
    
    this.vc_names = response.resp_data;
    this.isSaving = false;
  } );
}

onMyStartTime(select_time){
       
        var date_convert_1 = new Date(this.contactUsFormTab.get('start_date_and_time').value);
        var month_1 = date_convert_1.getMonth()+1;
        var c_start_date_and_time = (date_convert_1.getDate() < 10 ? '0' : '') + date_convert_1.getDate()+'-'+(date_convert_1.getMonth() < 10 ? '0' : '') + month_1 +'-'+date_convert_1.getFullYear();

        var date_convert_2 = new Date(this.contactUsFormTab.get('end_date_and_time').value);
        var month_2 =  date_convert_2.getMonth()+1;
        var c_end_date_and_time = (date_convert_2.getDate() < 10 ? '0' : '') + date_convert_2.getDate()+'-'+(date_convert_2.getMonth() < 10 ? '0' : '') + month_2 +'-'+date_convert_2.getFullYear();
        const v_fd  = new FormData(); 
        v_fd.append('s_select_time',select_time);
        v_fd.append('s_start_date', c_start_date_and_time);
        v_fd.append('s_end_date', c_end_date_and_time);
        this.isSaving = true;
        this._RegistrationService.getEndTime(v_fd).subscribe(response =>{

           this.to_tab_report_types = response.resp_data;
           this.isSaving = false;
        } );
        
  
}

getDealers(){
  
  this._RegistrationService.getDealerService().subscribe(data => {
         this.dealers_data = '';
         
         });
}

getContactCity(){
  
  this._RegistrationService.getCityServiceContactUs().subscribe(data => this.contact_cities_types = data.resp_data);
}

getVoCity(){
  
  this._RegistrationService.getCityServiceVo().subscribe(data => this.vo_cities_types = data.resp_data);
}
getTabCity(){
  
  this._RegistrationService.getCityServiceTab().subscribe(data => this.tab_cities_types = data.resp_data);
}

getTimeArray(){
  this._RegistrationService.getTimeArray().subscribe(data =>{
      this.to_tab_report_types = data.resp_data;
      this.tab_report_types = data.resp_data
      
   } );
}
getTbNewCity(){
  this._RegistrationService.getTbNewCity().subscribe(data => this.tabs_cities_types = data.resp_data);
}

getDemoCity(){
  
  this._RegistrationService.getDemoCity().subscribe(data => this.demo_cities_types = data.resp_data);
}
onBlurMethod(){
   alert("satendra")
}

}
